import DashboardCard from './DashboardCard.tsx';

const DashboardCardList = ({ cardList }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">

      {
        (cardList || [])?.map((row: any, i: number) => (

          <div key={i}><DashboardCard title={row.label} value={row.value} /></div>
        ))
      }
      {/* <DashboardCard title="Approved Requests" value={DashboardSummary.approvedRequests} />
      <DashboardCard title="Rejected Requests" value={DashboardSummary.rejectedRequests} />
      <DashboardCard title="Pending Requests" value={DashboardSummary.pendingRequests} />
      <DashboardCard
        title="Total Visits Time (hrs)"
        value={DashboardSummary.totalMeetingTimeHours}
      /> */}
    </div>
  );
};

export default DashboardCardList;
